import { NavDropdown, Nav } from "react-bootstrap";
import ShimmerScreen from "./ShimmerScreen";

const ShimmerForProfileTabs = () => {
  return (
    <NavDropdown.Item className="get_CertifiedContainer dropdownItem_notiFcation">
      <div className="getCertified">
        <a href="#"> </a>
      </div>
      <div className="getCertified_content w-100">
        <h6>
          <ShimmerScreen case="rect" height="1rem" width="100%" />
        </h6>
      </div>
    </NavDropdown.Item>
  );
};

export default ShimmerForProfileTabs;
